import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { ROLES } from '@auth/authRoles';

const PromoCodes = lazy(() => import('./PromoCodes'));
const PromoCodesListView = lazy(() => import('./views/PromoCodesListView'));
const PromoCodeFormView = lazy(() => import('./views/PromoCodeFormView'));

const PromoCodesRoute: FuseRouteItemType = {
	path: '/promo-codes',
	auth: [ROLES.Admin, ROLES.Manager, ROLES.Marketing],
	element: <PromoCodes />,
	children: [
		{ index: true, element: <PromoCodesListView /> },
		{ path: 'new', element: <PromoCodeFormView /> },
		{ path: ':id', element: <PromoCodeFormView /> }
	]
};

export default PromoCodesRoute;
